import {
  Alert,
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Spin,
  Statistic,
  Table,
  Tag,
  Upload,
} from 'antd';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import CustomerSelect from '../../lib/CustomerSelect';
import AddressCascader from '../../lib/AddressCascader';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
  OrderedListOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { notifyError, notifySuccess, priceFormat } from '../../store/utils';
import { API } from '../../api';

const { Dragger } = Upload;

const formItemLayout = {
  labelCol: {
    md: { span: 8 },
  },
  wrapperCol: {
    md: { span: 16 },
  },
};

const OrderBatch = () => {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [batchOrder, updateBatchOrder] = useState<any>(null);

  const streetNo = Form.useWatch('streetNo', form);

  const selectCustomer = useCallback(
    (customer: any) => {
      console.log('cccc', customer);
      if (customer === undefined || customer === null) {
        return;
      }

      form.setFieldsValue({
        senderFname: customer.name,
        senderPhone1: customer.phone1,
        senderPhone2: customer.phone2,
        streetNo: [
          customer?.street?.province?.no,
          customer?.street?.district?.no,
          customer?.street?.no,
        ].filter((it) => it),
        senderDetail: customer?.addressDetail,
      });
      setDisabled(false);
    },
    [form]
  );

  const fileUpload = useCallback(
    async ({ file }: any) => {
      try {
        setUploadLoading(true);
        const values = form.getFieldsValue();
        const payload = {
          ...values,
          streetNo: values.streetNo.at(-1),
        };
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'values',
          new Blob([JSON.stringify(payload)], { type: 'application/json' }),
          'values.json'
        );
        const {
          result: { data },
        } = await await API.post({ apiVersion: 'api' })(`/order/batch`, formData);
        updateBatchOrder(data);
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setUploadLoading(false);
      }
    },
    [form]
  );

  const fetchUpdateStreet = useCallback(async () => {
    if ((streetNo || []).length > 0 && batchOrder) {
      try {
        setUploadLoading(true);
        const customerNo = form.getFieldValue('customerNo');
        const payload = {
          senderStreetNo: streetNo.at(-1),
          batchOrderNo: batchOrder.no,
          customerNo,
        };
        const {
          result: { data },
        } = await API.put({ apiVersion: 'api' })(`/order/batch`, payload);
        updateBatchOrder(data);
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setUploadLoading(false);
      }
    }
  }, [streetNo, batchOrder, form]);

  const onFinish = useCallback(async () => {
    try {
      setLoading(true);
      await API.post({ apiVersion: 'api' })(`/order/batch/create/${batchOrder.no}`);
      notifySuccess('Захиалга амжилтай');
      form.resetFields();
      updateBatchOrder(null);
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  }, [batchOrder]);

  const successCounter = useMemo(() => {
    const items = (batchOrder?.items || []).filter((item: any) => item?.status?.code === 'ACTIVE');
    return items.length;
  }, [batchOrder]);

  const errorCounter = useMemo(() => {
    const items = (batchOrder?.items || []).filter(
      (item: any) => item?.status?.code === 'REJECTED'
    );
    return items.length;
  }, [batchOrder]);

  const columns = [
    {
      title: 'Мөр #',
      dataIndex: 'rowNum',
      render: (val: any, row: any, index: number) => <span>{index + 1}</span>,
    },
    {
      title: 'Баркод',
      key: 'barcode',
      render: (val: any, row: any) => {
        if (row.barcode) {
          if (row.checkBarcode) {
            return <div>{row.barcode}</div>;
          } else {
            return <div style={{ color: 'red' }}>{row.barcode}</div>;
          }
        } else {
          return <div />;
        }
      },
    },
    {
      title: 'Хүлээн авагч',
      dataIndex: 'receiverFname',
      render: (val: any, row: any) => (
        <div>{val ? val : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Х.Утас',
      dataIndex: 'receiverPhone1',
      render: (val: any, row: any) => (
        <div>{val ? val : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Хаяг',
      key: 'address',
      render: (val: any, row: any) => (
        <div>
          {row.receiverStreetNo ? (
            row.receiverProvince + ' ' + row.receiverDistrict + ' ' + row.receiverStreetName
          ) : (
            <span style={{ color: '#f50' }}>хоосон</span>
          )}
        </div>
      ),
    },
    {
      title: 'Хаяг Дэлгэрэнгүй',
      dataIndex: 'receiverDetail',
      render: (val: any, row: any) => (
        <div>{val ? val : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Ил.төрөл',
      dataIndex: 'itemType',
      render: (val: any) => <div>{val ? val : <span style={{ color: '#f50' }}>хоосон</span>}</div>,
    },
    {
      title: 'Анхаарах',
      dataIndex: 'warning',
      render: (val: any) => (
        <div>{val ? val.name : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Төл.төрөл',
      dataIndex: 'paymentType',
      render: (val: any) => (
        <div>{val ? val.text : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Хэмжээ',
      dataIndex: 'weightType',
      render: (val: any) => (
        <div>{val ? val.name : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Жин',
      dataIndex: 'weight',
      width: 80,
      render: (val: number) => (
        <div>{val ? `${priceFormat(val)} гр` : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Тоо.ш',
      dataIndex: 'quantity',
      render: (val: any) => <div>{val ? val : <span style={{ color: '#f50' }}>хоосон</span>}</div>,
    },
    {
      title: 'Үнэ',
      dataIndex: 'price',
      render: (val: any) => (
        <div>{val ? priceFormat(val) + '₮' : <span style={{ color: '#f50' }}>хоосон</span>}</div>
      ),
    },
    {
      title: 'Төлөв',
      dataIndex: 'status',
      render: (val: any, row: any) => (
        <div>
          {val.code === 'ACTIVE' ? (
            <Tag color="#87d068">боломжтой</Tag>
          ) : (
            <Tag color="#f50">боломжгүй</Tag>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchUpdateStreet();
  }, [streetNo]);

  return (
    <Card title="Захиалга файлаар оруулах">
      <Row>
        <Col offset={2} span={12}>
          <Form form={form}>
            <Form.Item
              {...formItemLayout}
              label="Харилцагч"
              name="customerNo"
              rules={[{ required: true, message: 'Харилцагч сонгоно уу!' }]}
            >
              <CustomerSelect
                allowClear
                showSearch
                onSelect={(customer: any) => selectCustomer(customer)}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Нэр"
              name="senderFname"
              rules={[{ required: true, message: 'Нэр сонгоно уу!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Утас"
              name="senderPhone1"
              rules={[{ required: true, message: 'Утас оруулна уу!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Утас 2" name="senderPhone2">
              <Input />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Зип код"
              name="streetNo"
              rules={[{ required: true, message: 'Хаяг сонгоно уу!' }]}
            >
              <AddressCascader />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Хаяг дэлгэрэнгүй"
              rules={[{ required: true, message: 'Хаяг дэлгэрэнгүй оруулна уу!' }]}
              name="senderDetail"
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item {...formItemLayout} label="what3words" name="senderW3w">
              <Input />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Divider />

      {batchOrder ? (
        <Fragment>
          <Row style={{ marginBottom: 24 }}>
            <Col span={24}>
              <Flex justify="center">
                <Button
                  type="primary"
                  disabled={!!errorCounter}
                  htmlType="button"
                  onClick={() => onFinish()}
                  loading={loading}
                >
                  Захиалгуудыг баталгаажуулах
                </Button>
                <Button
                  type="default"
                  style={{ marginLeft: 10 }}
                  icon={<ReloadOutlined />}
                  onClick={() => updateBatchOrder(null)}
                >
                  Дахин файл оруулах
                </Button>
              </Flex>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={4}>
              <Statistic
                title="Нийт мөр"
                value={(batchOrder?.items || []).length}
                valueStyle={{ fontSize: 36 }}
                prefix={<OrderedListOutlined />}
                suffix="ш"
              />
            </Col>
            <Col span={4}>
              <Statistic
                title="Амжилттай мөр"
                value={successCounter}
                valueStyle={{ color: '#3f8600', fontSize: 36 }}
                prefix={<CheckCircleOutlined />}
                suffix="ш"
              />
            </Col>
            <Col span={4}>
              <Statistic
                title="Алдаатай мөр"
                value={errorCounter}
                valueStyle={{ color: '#cf1322', fontSize: 36 }}
                prefix={<ExclamationCircleOutlined />}
                suffix="ш"
              />
            </Col>
          </Row>
          {errorCounter > 0 && (
            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col span={12} style={{ marginTop: 15 }}>
                <Alert
                  message="Алдаатай мөрийн хувьд захиалга үүсгэх боломжгүйг анхаарна уу!"
                  type="warning"
                />
              </Col>
            </Row>
          )}
          <Table
            rowKey={(record) => record.no}
            size="small"
            columns={columns}
            loading={uploadLoading}
            pagination={{ pageSize: 100 }}
            dataSource={batchOrder?.items || []}
          />
        </Fragment>
      ) : (
        <Row>
          <Col span={24}>
            <Dragger
              disabled={disabled || uploadLoading}
              name="file"
              showUploadList={false}
              beforeUpload={() => {
                return false;
              }}
              onChange={(info) => fileUpload(info)}
              multiple={false}
            >
              <p className="ant-upload-drag-icon">{uploadLoading ? <Spin /> : <InboxOutlined />}</p>
              <p className="ant-upload-text">
                Захиалгын excel файл чирж тавих эсвэл сонгож оруулна уу
              </p>
            </Dragger>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default OrderBatch;
